<template>
    <div class="cz2__steps-option cz2__steps-options__shared">
        <step-header
            :hasSubMenu="false"
            :showSubMenuTitle="true"
            :subMenuTitle="`${price} ${$t('EACH')}`"
            :showColorSwatches="false"
            :hasPrice="true"
        />

        <swiper
            topQuerySelector=".cz2__pet"
            selectedQuerySelector=".selection-card--selected"
            class="cz2__steps-options__list-wrapper"
        >
            <pets
                @updateNavigation="updateNavigation"
                :pet="pet"
                :currency="currency"
                @add="addPet"
            />
        </swiper>
    </div>
</template>

<script>
    import Swiper from './ui/Swiper.vue';
    import StepHeader from './ui/StepHeader.vue';
    import Pets from './Pets.vue';

    import * as constants from '../constants';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            StepHeader,
            Pets,
            Swiper,
        },

        data() {
            return {
                // TODO: Should be configured by e-comm.
                currency: 'USD',
                pet: null,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            price() {
                return formatPrice(this.$store.state, this.$store.getters.pets[0].price, 'compact');
            },
        },

        methods: {
            updateNavigation(navRules) {
                this.$emit('updateNavigation', {
                    ...navRules,
                    hasNext: true,
                    canGoNext: true,
                });
            },

            addPet(pet) {
                const toAdd = pet || this.pet;

                // Check if we already know about this one.
                let added = false;

                this.viewController.state.forEach((s) => {
                    if (s.placement.code === constants.PLACEMENT_PET_PREVIEW) {
                        return;
                    }

                    if (s.placement.code === constants.PLACEMENT_PET_PREVIEW_SECONDARY) {
                        return;
                    }

                    if (s.component.placementIndependentCode === toAdd.placementIndependentCode) {
                        if (this.viewController.isAvailable(s.component, s.component.quantityMultiplier + 1)) {
                            this.$store.dispatch('bumpVersion');

                            this.$store.dispatch('removeAlertFromPlacement', s.placement.code);

                            this.$store.dispatch('setComponentQuantity', {
                                component: s.component,
                                quantity: s.component.quantityMultiplier + 1,
                            });

                            this.$store.dispatch('syncPets');
                        }

                        added = true;
                    }
                });

                if (!added) {
                    let firstFree = null;

                    this.viewController.state.forEach((s) => {
                        if (constants.PLACEMENT_PETS.includes(s.placement.code)) {
                            if (s.component.placeholder) {
                                if (firstFree == null) {
                                    firstFree = s.placement;
                                }
                            }
                        }
                    });

                    if (firstFree) {
                        const select = firstFree.components.find((c) => c.placementIndependentCode === toAdd.placementIndependentCode
                            && this.viewController.isAvailable(c));

                        if (select) {
                            this.$store.dispatch('bumpVersion');

                            this.$store.dispatch('removeAlertFromPlacement', firstFree.code);

                            this.viewController.updateComponent(firstFree.code, select.code);

                            const setQuantity = this.viewController.selectedAtPlacement(firstFree.code);

                            this.$store.dispatch('setComponentQuantity', {
                                component: setQuantity,
                                quantity: 1,
                            });

                            this.$store.dispatch('syncPets');
                        }
                    }
                }

                this.pet = null;
            },

            formatPriceValue(price) {
                return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.currency, notation: 'compact' }).format(price);
            },
        },
    };
</script>
